import { render, staticRenderFns } from "./ApfDeclarationAndAgreement.vue?vue&type=template&id=54c85b16"
import script from "./ApfDeclarationAndAgreement.vue?vue&type=script&lang=js"
export * from "./ApfDeclarationAndAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports